<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl"/> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-world bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{ $t('website.sub-domain-detail') }}</h5>
                        </div>
                    </div>
                    <div>
                        <div class="py-3 px-0">
                        <div class="row mt-2 mx-2" v-if="dataResult">
                            <h5 class="pb-1 btn btn-light text-secondary">Sub domain: {{ JSON.parse(dataResult.subdomain).length }}</h5>
                          <table class="table table-bordered px-2">
                            <thead>
                              <tr>
                                <td width="5%" class="text-center"><b>No</b></td>
                              <td>
                                <b>IP Address </b>
                              </td>
                              <td>
                                <b>Sub Domain </b>
                              </td>
                              </tr>
                            </thead>
                              <tbody>
                                <tr v-for="(sub, index) in JSON.parse(dataResult.subdomain)" :key="index">
                                     <td class="text-center">
                                      {{index+1}}
                                  </td>
                                  <td>
                                      {{sub.ip}}
                                  </td>
                                  <td>
                                      {{sub.subdomain}}
                                  </td>
                                </tr>
                            </tbody>
                          </table>
                        </div>
                        </div>
                    </div>
                   </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            backUrl: "/subdomain-checker",
            id: this.$route.params.id,
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            dataResult:"",
            search:false,
            title: this.$t('website.sub-domain-detail'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-subdomain'),
               href: "/subdomain-checker"
                },
                {
                text: this.$t('website.sub-domain-detail'),
                active: true
                }
            ],
        }
    },
    methods:{
        getsubDomain(){
        this.loading = true;
          WebsiteService.getSubDomainDetail(this.id)
          .then(response => {
                    // console.log(response);
                    this.dataResult = response.data.data;
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = flase;
            });
        },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
  },
    mounted(){
        this.totalRows = this.items.length;
        this.getsubDomain();
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>